var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.1112 6H5.88894C5.39802 6 5.00005 6.39797 5.00005 6.88889V7.11111C5.00005 7.60203 5.39802 8 5.88894 8H18.1112C18.6021 8 19 7.60203 19 7.11111V6.88889C19 6.39797 18.6021 6 18.1112 6ZM13.1112 11H5.88894C5.39802 11 5.00005 11.398 5.00005 11.8889V12.1111C5.00005 12.602 5.39802 13 5.88894 13H13.1112C13.6021 13 14 12.602 14 12.1111V11.8889C14 11.398 13.6021 11 13.1112 11ZM18.1112 16H5.88894C5.39802 16 5.00005 16.398 5.00005 16.8889V17.1111C5.00005 17.602 5.39802 18 5.88894 18H18.1112C18.6021 18 19 17.602 19 17.1111V16.8889C19 16.398 18.6021 16 18.1112 16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlign);
export default __webpack_public_path__ + "static/media/left-align.48b30fab053729302b8f9967ce1c0013.svg";
export { ForwardRef as ReactComponent };